export default function MotivationSection() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-slate-50 via-white to-slate-50 text-slate-900 py-16 md:py-20">
      {/* Background blobs */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-24 left-1/2 h-[520px] w-[520px] -translate-x-1/2 rounded-full bg-gradient-to-br from-cyan-200/55 via-sky-200/40 to-indigo-200/40 blur-3xl" />
        <div className="absolute -bottom-40 right-[-120px] h-[420px] w-[420px] rounded-full bg-gradient-to-br from-emerald-200/40 via-lime-200/30 to-cyan-200/35 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-[1280px] px-6 md:px-8">
        {/* Header */}
        <div className="mb-10 text-center">
          <h2 className="text-5xl font-extrabold uppercase tracking-wide text-blue-600 sm:text-5xl">
            Motivation
          </h2>
          <p className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
            Quantitative Trading Is Powerful —
            <br />
            But Still Too Hard for Most People
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-500">
            Fragmented data, complex steps, and coding requirements make quant trading too difficult for many users.
          </p>
        </div>

        {/* Side-by-side comparison */}
        <div className="mx-auto max-w-5xl mt-12 flex items-center justify-center gap-0">
          {/* Traditional box */}
          <div className="flex-1 rounded-2xl border-2 border-slate-200 overflow-hidden bg-white shadow-[0_4px_20px_0_rgba(0,0,0,0.08)]">
            <img
              alt="Traditional Quantitative Trading"
              src="/assets/home/traditional.webp"
              className="w-full h-auto block"
            />
          </div>

          {/* Arrow */}
          <div className="flex-shrink-0 px-5 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="48" viewBox="0 0 64 48" fill="none">
              <defs>
                <linearGradient id="arrowGradMotiv" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#06b6d4" />
                  <stop offset="100%" stopColor="#3b82f6" />
                </linearGradient>
              </defs>
              <path
                d="M4 24 H52 M40 10 L56 24 L40 38"
                stroke="url(#arrowGradMotiv)"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* LingCopilot box */}
          <div className="flex-1 rounded-2xl border-2 border-blue-300 overflow-hidden bg-white shadow-[0_4px_20px_0_rgba(59,130,246,0.15)]">
            <img
              alt="LingCopilot"
              src="/assets/home/lingcopilot.webp"
              className="w-full h-auto block"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
